import { VideoMedia, VideoSchema } from '~/lib';

export const extractVideoSource = (
    embeddedSource?: VideoMedia,
    uploadedSource?: VideoSchema,
): VideoMedia | undefined => {
    if (uploadedSource?.videoFile?.src) {
        return {
            src: uploadedSource.videoFile.src,
            mute: uploadedSource.videoMute ?? false,
            autoPlay: uploadedSource.videoAutoPlay ?? false,
            loop: uploadedSource.videoLoop ?? false,
            theaterMode: uploadedSource.videoTheaterMode ?? false,
        };
    }

    if (embeddedSource?.src) return embeddedSource;

    return undefined;
};
